import { FunctionComponent, useCallback } from 'react'
import { format } from 'date-fns'
import { downloadBlob } from '../../../misc/blob.utilities'
import { RoundedButton } from '../../shared'
import { formatStatsValue } from '../utils/displayContent.utils'
import { ResultDataTableProps } from './ResultDataTable.model'
import { buildResultDataCsv } from './resultDataCsv'
import styles from './ResultDataTable.module.scss'

export const ResultDataTable: FunctionComponent<ResultDataTableProps> = ({ content }) => {
  const { columns, rows, truncated } = content

  const handleExportCsv = useCallback(() => {
    const blob = new Blob([buildResultDataCsv(content)], { type: 'text/csv;charset=utf-8' })
    downloadBlob(blob, `statistiques_${format(new Date(), 'yyyy-MM-dd_HH-mm')}.csv`)
  }, [content])

  return (
    <div className={styles.wrapper}>
      {truncated && (
        <div className={styles.truncatedBanner}>
          Affichage des {rows.length} premières lignes — affinez votre question pour voir plus de
          détails.
        </div>
      )}
      <div className={styles.tableScroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.name}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={`row-${rowIndex}`}>
                {row.map((cell, cellIndex) => (
                  <td key={`${rowIndex}-${cellIndex}`}>{formatStatsValue(cell)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles.actions}>
        <RoundedButton
          label="Export CSV"
          icon="export"
          theme="transparent-dark"
          size="micro"
          onClick={handleExportCsv}
          testId="button-stats_assistant-export_csv"
        />
      </div>
    </div>
  )
}
